var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-page-content-template',{attrs:{"title":_vm.$t('AIエステ'),"subtitle":_vm.$t('AIエステ.顔診断エステ')}},[_c('step-contents',{attrs:{"steps":_vm.steps}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }